import React from 'react';
import ReactDOM from 'react-dom/client';
import 'animate.css';
import MainRouter from './routes/MainRouter';
import './styles/main.scss'; // Importar estilos globales
import {addLocale, PrimeReactProvider} from 'primereact/api'; // <--- Import addLocale
import './index.scss'
// Configure the Spanish locale
addLocale('es', {
    firstDayOfWeek: 0, // Sunday
    dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
    monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    today: 'Hoy',
    clear: 'Limpiar',
    dateFormat: 'dd/mm/yy', // <-- THIS MUST MATCH THE `dateFormat` PROP IN YOUR CALENDAR
    weekHeader: 'Sm',
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <PrimeReactProvider value={{ ripple: true }}>
        <React.StrictMode>
            <MainRouter />
        </React.StrictMode>
    </PrimeReactProvider>
);

